import { render, staticRenderFns } from "./LinkProducts.vue?vue&type=template&id=5faaa230&scoped=true&"
import script from "./LinkProducts.vue?vue&type=script&lang=js&"
export * from "./LinkProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faaa230",
  null
  
)

export default component.exports